// Seniority levels matching Theirstack API format
// These values are stored directly in the database
export enum SeniorityLevel {
  JUNIOR = 'junior',
  MID_LEVEL = 'mid_level',
  SENIOR = 'senior',
  STAFF = 'staff',           // Displayed as "Manager" in UI
  C_LEVEL = 'c_level',       // Displayed as "C-Suite" in UI
}

export interface OnboardingData {
  cvFile: File | null;
  name: string;
  linkedinUrl: string;
  country: string;
  city: string;
  workEligibility: boolean | null;
  seniority: SeniorityLevel | null;
  years_of_experience: number | null;
  industry: string;
  role: string;
}

export const INITIAL_ONBOARDING_DATA: OnboardingData = {
  cvFile: null,
  name: '',
  linkedinUrl: '',
  country: '',
  city: '',
  workEligibility: null,
  seniority: null,
  years_of_experience: null,
  industry: '',
  role: '',
};

